import { Reducer } from 'redux';
import { VASProcessedState, VASProcessedTypes } from './types';
import { AuthActionTypes } from '../auth';

export const initialState: VASProcessedState = {
  vasError: undefined,
  exportError: undefined,
  exportStream: undefined,
  isExportError: false,
  isExportSuccess: false,
  isExporting: false,
  loading: false,
  vasExportError: undefined,
  vas: null,
};

const reducer: Reducer<VASProcessedState> = (state = initialState, action) => {
  switch (action.type) {
    case VASProcessedTypes.VIEW_VAS_OVERVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        vas: null,
        vasError: undefined,
        vasExportError: undefined,
      };
    case VASProcessedTypes.VIEW_VAS_OVERVIEW_SUCCESS:
      return {
        ...state,
        vas: action.payload,
        loading: false,
        vasError: undefined,
      };
    case VASProcessedTypes.VIEW_VAS_OVERVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        vasError: action.payload,
      };

    case VASProcessedTypes.CLEAR_VAS:
      return {
        ...state,
        vas: null,
        vasError: undefined,
        vasExportError: undefined,
      };
    case VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_REQUEST:
      return {
        ...state,
        isExporting: true,
        exportError: undefined,
        vasExportError: undefined,
      };
    case VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_SUCCESS:
      return {
        ...state,
        isExporting: false,
        exportStream: action.payload,
        isExportError: false,
        isExportSuccess: true,
        exportError: undefined,
        vasExportError: undefined,
      };
    case VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_FAILURE:
      return {
        ...state,
        isExporting: false,
        exportStream: undefined,
        isExportError: true,
        isExportSuccess: false,
        exportError: action.payload,
        vasExportError: action.payload,
      };

    case AuthActionTypes.DESTROY_STATES:
      return initialState;
    default:
      return state;
  }
};

export { reducer as vasReducer };
